import React, {useEffect, useState } from "react";
import {  getJobOpening, 
    // getLoggedInUser,
 } from "../../utils/helper";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Loader from "../../utils/Loader";
import { useParams, 
    useHistory
 } from "react-router-dom";
import { alertError, 
    // alertSuccess
 } from "../../utils/alerts";

const INIT_STATE = {
    jobTitle: "",
    jobType: "",
    industry: "",
    location: "",
    min_qualification: "",
    experience_length:"",
    job_level: "",
    currency:"",
    monthly_salary:"",
    negotiable: "",
    days_online: "",
    available_openings: "",
};

export default function ViewJobOpening() {
    const { id } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [state, setState] = useState(INIT_STATE);
    const [job, setJobOpening] = useState(null);
    const [overview, setJobOverview] = useState(null);
    // const [profile, setProfile] = useState("");
    // const TOKEN = localStorage.getItem("kloka:token:data");

    // useEffect(()=>{
    //     if(TOKEN){
    //         getLoggedInUser(TOKEN).then((res) => {
    //             setProfile(res.data.data);
    //         });
    //     }
    // }, [TOKEN]);

    useEffect(() => {
        if(id){
            getJobOpening(id)
                .then((res) => {
                    if(res.data.success){
                        setJobOpening(res.data.data);
                        setJobOverview(res.data.overview);
                    }else {
                        alertError(res.data.message);
                    }
                })
                .catch((err) => {
                    console.log(err?.response?.data?.error)
                });
        }
        setLoading(false);
    }, [id]); 

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            jobTitle: (job && job.jobTitle ) || "",
            jobType: (job && job.jobType ) || "",
            industry: (job && job.industry) || "",
            location: (job && job.location) || "",
            jobDescription: (job && job.jobDescription) || "",
            jobSummary: (job && job.jobSummary) || "",
            currency: (job && job.currency) || "",
            monthly_salary: (job && job.monthly_salary) || "",
            negotiable: (job && job.negotiable) || "",
            days_online: (job && job.days_online) || "",
            available_openings: (job && job.available_openings) || "",
            status: (job && job.status) || "",
            min_qualification: (job && job.min_qualification) || "",
            experience_length: (job && job.experience_length) || "",
            job_level: (job && job.job_level) || "",
        }));
    }, [job]);

    const navigateById = (path, id, sec) => {
        history.push(`${path}/${id}/${sec}`);
    };

    return (
        <>  
            {(job && job._id) ? 
                <div className="spur-card-menu"><button onClick={()=> navigateById("/recruitment/job", job._id, "applicants")} 
                className="pull-right btn topbtn btn-primary">VIEW APPLICANTS</button></div>
            : null}
            
            
            <h1 className="dash-title"><Link to="/recruitment/jobs" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                <div className="col-md-12 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" 
                                style={{fontSize: 20, fontWeight:'bold', marginBottom: 20, 
                                paddingBottom:20, borderBottom: '1px solid #ccc', }}>
                                Job Details 
                                
                            </h3>
                            <div className="row">
                                {(state && state.jobTitle) ? <>
                                <div className="col-md-6">
                                    <ul className="personal-info">
                                        <li>
                                            <div className="title">Job Title:</div>
                                            <div className="text">{state.jobTitle && state.jobTitle}</div>
                                        </li>
                                        <li>
                                            <div className="title">Job Type:</div>
                                            <div className="text">{state.jobType && state.jobType}</div>
                                        </li>
                                        <li>
                                            <div className="title">Industry:</div>
                                            <div className="text"><span>{state.industry && state.industry} </span></div>
                                        </li>
                                        <li>
                                            <div className="title">Location:</div>
                                            <div className="text">{state.location && state.location}</div>
                                        </li>
                                        <li>
                                            <div className="title">Minimum Qualification:</div>
                                            <div className="text">{state.min_qualification && state.min_qualification} </div>
                                        </li>
                                        <li>
                                            <div className="title">Experience Length:</div>
                                            <div className="text">{state.experience_length && state.experience_length}</div>
                                        </li>
                                        
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <ul className="personal-info">
                                        <li>
                                            <div className="title">Job Level:</div>
                                            <div className="text">{state.job_level && state.job_level}</div>
                                        </li>
                                        <li>
                                            <div className="title">Currency:</div>
                                            <div className="text">{state.currency && state.currency}</div>
                                        </li>
                                        <li>
                                            <div className="title">Monthly Salary:</div>
                                            <div className="text"><span>{state.monthly_salary && state.monthly_salary} </span></div>
                                        </li>
                                        <li>
                                            <div className="title">Is Salary negotiable?:</div>
                                            <div className="text">{state.negotiable && state.negotiable}</div>
                                        </li>
                                        <li>
                                            <div className="title">Days Online:</div>
                                            <div className="text">{state.days_online && state.days_online} days</div>
                                        </li>
                                        <li>
                                            <div className="title">Available Openings:</div>
                                            <div className="text">{state.available_openings && state.available_openings}</div>
                                        </li>
                                    </ul>
                                </div>
                                {/* <div className="col-md-12">
                                    <ul className="personal-info">
                                        <li>
                                            <div className="title">Job Summary:</div>
                                            <div className="text">{state.jobSummary && state.jobSummary}</div>
                                        </li>
                                        <li>
                                            <div className="title">Job Description /  Requirements:</div>
                                            <div className="text">{state.jobDescription && state.jobDescription}</div>
                                        </li>
                                    </ul>
                                </div> */}
                                </> : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>

                {(job && job) ? <>  
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 15}}>
                        <div className="card-header">
                            <div className="spur-card-title">Overview</div>
                            {/* <div className="spur-card-menu">
                                <form className="btn-group" onSubmit={()=> console.log(state)}>
                                    <select className="form-control form-select" required="required" >
                                        <option value=''>Select option...</option>
                                        <option value='expire'>Expire Job</option>
                                    </select>
                                    <button type="submit" className="btn">SUBMIT </button>
                                </form>
                            </div> */}
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {!loading && job ? <>                                    
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                            
                                        </div>

                                        <div className="col-md-6 col-sm-12">
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6">
                                                    <div className="ats_mini_card">
                                                        <h5>Total Views</h5>
                                                        <span className="number views">6,907</span>    
                                                    </div>    
                                                </div> 
                                                {overview && overview.map((row, i) => (
                                                    <div className="col-md-6 col-sm-6" key={i}>
                                                        <div className="ats_mini_card">
                                                            <h5>{row.name && row.name}</h5>
                                                            <span className={`number ${row.label}`}>{row.count && row.count}</span>    
                                                        </div>    
                                                    </div>  
                                                ))}  
                                            </div>                                            
                                        </div>
                                    </div>
                                </> :  <Loader /> }
                            </div>
                        </div>
                    </div> 
                </div> </> : null }
            </div>
        </>
    );
}